import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';

import './css/style.css';
// import './charts/ChartjsConfig';

// Import pages
// import Dashboard from './pages/Dashboard';
import UsersManagement from './pages/usersManagement';
import OrganizationManagement from './pages/OrganizationManagement';
import CustomerJourneyManagement from './pages/CustomerJourneyManagement';
import OperationJourneyManagement from './pages/OperationJourneyManagement';
import CapabilityMapsManagement from './pages/CapabilityMaps';
import Industry from './pages/Industry';
import Login from './pages/Auth';
import Layout from './components/Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Tickets from './pages/Tickets';
import TicketDetails from './pages/TicketDetails';
import SupportDashboard from './pages/SupportDashboard';
import HelpCenter from './pages/helpCenter';

const queryClient = new QueryClient();

// Private route component
function PrivateRoute({ element: Component }) {
  const token = localStorage.getItem('accessToken'); // Check for token in localStorage

  return token ? (
    <Layout>
      <Component />
    </Layout>
  ) : (
    <Navigate to="/Login" replace />
  );
}

function App() {
  const location = useLocation();

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html').style.scrollBehavior = '';
  }, [location.pathname]); // triggered on route change

  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <Routes>
        {/* Protected Routes */}
        <Route path="/" element={<PrivateRoute element={UsersManagement} />} />
        {/* <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} /> */}
        <Route path="/users" element={<PrivateRoute element={UsersManagement} />} />
        <Route path="/organization" element={<PrivateRoute element={OrganizationManagement} />} />
        <Route path="/customerJourney" element={<PrivateRoute element={CustomerJourneyManagement} />} />
        <Route path="/industry" element={<PrivateRoute element={Industry} />} />
        <Route path="/operationJourney" element={<PrivateRoute element={OperationJourneyManagement} />} />
         <Route path="/tickets" element={<PrivateRoute element={Tickets} />} />
         <Route path="/tickets/:id" element={<PrivateRoute element={TicketDetails} />} />
         <Route path="/support-dashboard" element={<PrivateRoute element={SupportDashboard} />} />
         <Route path="/capability-maps" element={<PrivateRoute element={CapabilityMapsManagement} />} />
         <Route path="/help-center" element={<PrivateRoute element={HelpCenter} />} />




        {/* Public Route */}
        <Route path="/Login" element={<Login />} />
      </Routes>
    </QueryClientProvider>
  );
}

export default App;
